import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { AccountService } from './account.service';
import { EditableAccountDTO } from '../model/account.model';
import {Observable, of, Subject} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class UserService {
    public authenticated = false;

    private account: EditableAccountDTO;

    public auth2 = new Subject<boolean>();
    public auth2Observable = this.auth2.asObservable();

    constructor(
        private accountService: AccountService,
        private http: HttpClient
    ) { }

    getAccount(force?: boolean): Promise<EditableAccountDTO> {
        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving unless we want to force the refresh
        if (this.account && !force) {
            return Promise.resolve(this.account);
        }

        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.accountService.get().toPromise().then(account => {
            this.account = account;
            return this.account;
        }).catch(_err => {
            this.account = null;
            return this.account;
        });
    }

    getIsAuthenticated(force?: boolean): Observable<boolean> {
        if (this.authenticated !== null && !force) {
            return of(this.authenticated);
        }
        return this._isAuthenticated();
    }

    clearUserState() {
        this.account = null;
        this.authenticated = false;
        this.auth2.next(this.authenticated);
    }

    private _isAuthenticated(): Observable<boolean> {
        return this.http.get('/api/authenticate', {responseType: 'text'}).pipe(map((response: string) => {
            this.authenticated = !!response;
            this.auth2.next(this.authenticated);
            return this.authenticated;
        }), catchError(error => {
            console.error('_isAuthenticated: ', error);
            this.clearUserState();
            return of(false);
        }));
    }

    subscribeUserClub(): Promise<any> {
        return this.http.patch(`/api/account/user-club/subscribe`, null).toPromise();
    }

    unsubscribeUserClub(): Promise<any> {
        return this.http.patch(`/api/account/user-club/unsubscribe`, null).toPromise();
    }

    getIsUserClubMember(): Promise<boolean> {
        return this.http.get<boolean>(`/api/account/user-club`).toPromise();
    }

    isRememberMe(): Promise<boolean> {
        return this.http.get<boolean>('/api/remember-me').toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/services/user.service.ts